import { useMutation } from '@tanstack/react-query';
import { apiService } from '../../../services/api';

// STD-015: imperative actions for the Profile tab. apiService is imported
// here (a *.mutations.ts file) per STD-016. The "get flights for plotting"
// call is user-triggered (button click) and drives a side-effect (opening
// the analytics tab), so it lives here as a mutation. The component handles
// errors inline via showError, so the mutation opts out of the global toast.

export function useFetchFlightsForPlottingMutation() {
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: ({ serial, start, end }: { serial: string; start: string; end: string }) =>
      apiService.getFlightsForPlotting(serial, start, end),
  });
}
